var _path;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
class IconSpeedGraderLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return _jsx(SVGIcon, {
      ...this.props,
      name: "IconSpeedGrader",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef,
      children: _path || (_path = _jsx("path", {
        d: "M1865.912 880.774c18.862 57.939 32.189 117.798 39.643 178.108 4.743 39.643 7.228 79.172 7.228 119.83 0 40.66-2.485 80.19-7.228 119.719-21.007 170.089-88.207 332.385-194.372 469.383l-89.223-69.12c93.74-120.96 153.035-264.17 171.557-413.93 4.179-35.011 6.325-70.023 6.325-106.051 0-36.028-2.146-71.04-6.438-106.165-6.437-52.97-18.183-105.713-34.899-156.65Zm-1753.874 403.99c18.522 149.76 77.816 292.97 171.557 413.93l-89.223 69.12C88.207 1630.816 21.007 1468.52 0 1298.544ZM1816.33 456.59l79.85 79.962-886.927 886.927L498.76 912.985l79.849-79.85 430.645 430.645 807.077-807.19ZM194.371 589.612l89.224 69.12c-93.74 120.96-153.035 264.17-171.557 413.93L0 1058.881c21.007-169.976 88.207-332.273 194.372-469.27Zm878.265-363.66c169.977 20.895 332.273 88.208 469.27 194.372l-69.12 89.224c-121.072-93.741-264.169-153.036-413.929-171.558Zm-239.695-.01 13.779 112.037C696.96 356.5 553.75 415.795 432.79 509.536l-69.12-89.223C500.669 314.148 662.966 246.948 832.942 225.94Z",
        fillRule: "evenodd"
      }))
    });
  }
}
IconSpeedGraderLine.glyphName = 'speed-grader';
IconSpeedGraderLine.variant = 'Line';
IconSpeedGraderLine.displayName = 'IconSpeedGraderLine';
IconSpeedGraderLine.allowedProps = [...SVGIcon.allowedProps];
export default IconSpeedGraderLine;
export { IconSpeedGraderLine };